import { useCallback, useContext, useEffect, useMemo, useState } from "react"
import { callautopopulate } from "../../../services/callautopop";
import _ from 'underscore';
import { ToastContext } from "../../../context/ToastContext";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { Calendar } from "primereact/calendar";
import { dateConvert } from "../../../utils/Helper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";

export const useProjectMember = ({ projectData }) => {
    const { showInfo, showSuccess, showError } = useContext(ToastContext);
    const [options, setOptions] = useState();
    const [fieldValues, setFieldValues] = useState({});
    const [showAddInput, setShowAddInput] = useState(false);
    const [categoryData, setCategoryData] = useState([]);
    const [memberList, setMemberList] = useState([]);
    const [filterData, setFilterData] = useState([])
    const [filterValues, setFilterValues] = useState({ type: true, category: "all" })
    const [showPopup, setShowPopup] = useState({
        show: false,
        data: null,
    });

    useEffect(() => {
        callautopopulate("all_users", "project_role", "issue_type", "project_role_category").then(res => {
            setOptions({
                users: _.sortBy(res?.all_users, "user_display_name").map(item => { return { ...item, label: item?.user_display_name } }),
                projectRole: _.sortBy(res?.project_role, "project_role_name").map(item => { return { ...item, label: item?.project_role_name } }),
                issueTypes: _.sortBy(res?.issue_type, "issue_type_name"),
                category: _.sortBy(res?.project_role_category, "category_name").map(item => { return { ...item, label: item?.category_name } }),

            })
        })
    }, [])

    const formJson = [
        {
            step: 1,
            label: "Member Details",
            fields: [
                {
                    name: "user",
                    col: "12",
                    type: "select",
                    placeholder: "Select Member",
                    option: options?.users,
                    disabled: false
                },
                {
                    name: "projectRole",
                    col: "12",
                    type: "select",
                    placeholder: "Select Role",
                    option: options?.projectRole,
                    disabled: false
                },
                {
                    name: "communicators_ids",
                    col: "12",
                    type: "multiselect",
                    placeholder: "Communicators",
                    option: _.filter(options?.category, (item) => item?.category_id !== fieldValues?.category_id) || [],
                    disabled: false,
                    optionLabel: "category_name",
                    optionValue: "category_id"
                },
                {
                    name: "issueType",
                    col: "12",
                    type: "multiselect",
                    placeholder: "Select Issue Type",
                    option: options?.issueTypes,
                    disabled: false,
                    optionLabel: "issue_type_name",
                    optionValue: "issue_type_id"
                },
                {
                    name: "alloted_date",
                    col: "12",
                    type: "date",
                    placeholder: "Start Date",
                    disabled: false,
                    min: new Date(new Date().setDate(new Date().getDate() - 2))
                },
                {
                    name: "expired_date",
                    col: "12",
                    type: "date",
                    placeholder: "End Date",
                    disabled: false,
                    min: new Date(fieldValues?.alloted_date),
                    max: fieldValues?.projectRole?.exp_days > 0
                        ? new Date(new Date().setDate(
                            new Date().getDate() + fieldValues?.projectRole?.exp_days
                        )) : new Date(new Date().setDate(
                            new Date().getDate() + 30
                        ))

                },
                {
                    label: "Billable",
                    name: "is_billable",
                    col: "12",
                    type: "checkbox",
                    required: true,
                    disabled: false
                },
            ]
        },
    ]

    const columns = [
        {
            label: "Member",
            key: "user_display_name",
            style: { width: "12%", },
            render: (row) => <div className="px-1 text-truncate w100" >{row?.user_display_name}</div>
        },
        {
            label: "Role",
            style: { width: "12%" },
            key: "project_role_name",
            render: (row) => <div className="px-1 text-truncate">{row?.project_role_name}</div>
        },
        {
            label: "Communicators",
            key: "communicators_ids",
            sort: false,
            headerStyle: { textAlign: "center" },
            style: { width: "12%", textAlign: "center", },
            render: (row) => {
                const selectedData = _.pluck(_.filter(options?.category, (item) => row?.communicators_ids?.includes(item?.category_id)), "category_name");
                const tooltipValue = selectedData?.length > 1 ? selectedData?.join("\n") : selectedData?.[0] || "";
                return (
                    <div className="px-2 w100 position-relative" title={tooltipValue}>
                        <MultiSelect
                            placeholder="Select"
                            options={_.filter(options?.category, (item) => item?.category_id !== row?.category_id) || []}
                            optionLabel="category_name"
                            optionValue="category_id"
                            filter
                            filterInputAutoFocus
                            className="sk-multiselect w100"
                            panelClassName="sk-multiselect-panel"
                            name="issue_type"
                            maxSelectedLabels={0}
                            value={row?.communicators_ids || []}
                            onChange={(e) => {
                                row.communicators_ids = e.target.value || [];
                                row.isChange = true
                                setMemberList([...memberList]);

                            }}
                            disabled={!filterValues?.type}
                            onHide={() => row?.isChange && upsertUserRoleAPI(row, row.communicators_ids || [], "communicators_ids")}
                        />
                    </div>
                );
            }
        },
        {
            label: "Alloted Date",
            key: "alloted_date",
            headerStyle: { textAlign: "center", },
            style: { width: "12%", textAlign: "center", },
            render: (row) => <div>{row?.alloted_date && dateConvert(row?.alloted_date, "day-month-year")}</div>
        },
        {
            label: "Expiry Date",
            key: "Expiry",
            sort: false,
            headerStyle: { textAlign: "center" },
            style: { width: "12%" },
            render: (row) => {
                return (
                    <div className="inspectra-calendar px-1 w100">
                        <Calendar
                            value={new Date(row?.expired_date)}
                            dateFormat="dd M yy"
                            className="input-dd"
                            placeholder="Expiry Date"
                            onChange={(e) => upsertUserRoleAPI(row, e.target.value, "expired_date")}
                            disabled={!filterValues?.type}
                        />
                    </div>
                );
            }
        },
        {
            label: "Issue Types",
            key: "issue_type_id",
            sort: false,
            headerStyle: { textAlign: "center" },
            style: { width: "13%", textAlign: "center", },
            render: (row) => {
                const selectType = _.pluck(_.filter(options?.issueTypes, (item) => row?.issueType?.includes(item?.issue_type_id)), "issue_type_name");
                const tooltipValue = selectType?.length > 1 ? selectType?.join("\n") : selectType?.[0] || "";
                return (
                    <div className="px-2 w100 position-relative" title={tooltipValue}>
                        <MultiSelect
                            placeholder="Select"
                            options={options?.issueTypes}
                            optionLabel="issue_type_name"
                            optionValue="issue_type_id"
                            filter
                            filterInputAutoFocus
                            className="sk-multiselect w100"
                            panelClassName="sk-multiselect-panel"
                            name="issue_type"
                            value={row?.issueType || []}
                            maxSelectedLabels={0}
                            onChange={(e) => {
                                row.issueType = e.target.value || [];
                                row.isChange = true
                                setMemberList([...memberList]);

                            }}
                            onHide={() => row?.isChange && upsertUserRoleAPI(row, row.issueType || [], "issueType")}
                            disabled={!filterValues?.type}
                        />
                    </div>
                );
            }
        },
        {
            label: "Billable",
            key: "Billable",
            style: { width: "6%", textAlign: "center", },
            sort: false,
            render: (row) => {
                return (
                    <input
                        type="checkbox"
                        checked={
                            row?.is_billable === undefined
                                ? true
                                : row?.is_billable
                        }
                        onChange={(e) => setShowPopup({ show: true, data: row, newValue: e.target.checked, list: true })}
                        disabled={!filterValues?.type}
                    />
                );
            }
        },
        {
            label: "Build Approver",
            key: "Approver",
            sort: false,
            style: { width: "6%", textAlign: "center", },
            render: (row) => {
                return (
                    <input
                        title="Build Allow"
                        type="checkbox"
                        checked={
                            row?.is_build_allow === undefined
                                ? false : row?.is_build_allow
                        }
                        onChange={(e) => upsertUserRoleAPI(row, e.target.checked, "is_build_allow")}
                        disabled={!filterValues?.type}
                    />
                );
            }
        },
        {
            label: "Server",
            key: "is_server_build_allow",
            sort: false,
            headerStyle: { textAlign: "center" },
            style: { width: "6%", textAlign: "center", },
            render: (row) => {
                return (
                    <input
                        title="Server Build Allow"
                        type="checkbox"
                        checked={
                            row?.is_server_build_allow === undefined
                                ? false : row?.is_server_build_allow
                        }
                        onChange={(e) => upsertUserRoleAPI(row, e.target.checked, "is_server_build_allow")}
                        disabled={!filterValues?.type}
                    />
                );
            }
        },
        {
            label: "Build Requester",
            key: "is_auto_build_request_permission",
            sort: false,
            style: { width: "6%", textAlign: "center", },
            render: (row) => {
                return (
                    <input
                        type="checkbox"
                        checked={
                            row?.is_auto_build_request_permission === undefined
                                ? true
                                : row?.is_auto_build_request_permission
                        }
                        onChange={(e) => upsertUserRoleAPI(row, e.target.checked, "is_auto_build_request_permission")}
                        disabled={!filterValues?.type}
                    />
                );
            }
        },
        {
            label: "",
            key: "action",
            sort: false,
            style: { width: "3%", textAlign: "center", },
            hide: !filterValues?.type,
            render: (row) => {
                return (
                    <FontAwesomeIcon
                        icon="fa-solid fa-trash"
                        className="remove"
                        onClick={() => deleteMember(row)}
                    />
                );
            }
        }
    ]

    const handleChange = (obj, e) => {
        if (obj?.name === "projectRole") {
            const result = new Date();
            const daysToAdd = e.target.value?.exp_days ? e.target.value?.exp_days : 30;
            result.setDate(result.getDate() + daysToAdd);
            setFieldValues((prev) => ({ ...prev, [obj?.name]: e.target.value, alloted_date: new Date(), expired_date: result }));
        } else if (obj?.name === "alloted_date") {
            const result = new Date(e.target.value);
            const daysToAdd = fieldValues?.projectRole?.exp_days ? fieldValues?.projectRole?.exp_days : 30;
            result.setDate(result.getDate() + daysToAdd);
            setFieldValues((prev) => ({ ...prev, [obj?.name]: e.target.value, expired_date: result }))
        } else if (obj.name === "user") {
            setFieldValues((prev) => ({ ...prev, [obj?.name]: e.target.value, is_billable: e.target.value?.is_billable }));
        } else if (obj.name === "is_billable") {
            setShowPopup({ show: true, data: fieldValues?.user, newValue: e.target.checked })
        } else {
            setFieldValues((prev) => ({ ...prev, [obj?.name]: e.target.value }));
        }
    }

    useEffect(() => {
        if (filterValues?.category === "all" || !filterValues?.category) {
            setFilterData(memberList)
        }
        else {
            setFilterData(_.filter(memberList, { id: filterValues?.category }));
        }
    }, [filterValues?.category, memberList])

    const upsertUserRoleAPI = async (rowData, newValue, key) => {
        if (!projectData?.project_id) return;
        try {

            if (!rowData?.user?.user_code && !rowData.user_code) {
                showInfo("info", "Please select a member.");
                return;
            }
            if (!rowData.projectRole?.project_role_id && !rowData?.project_role_id) {
                showInfo("info", "Please select a project role.");
                return;
            }
            if (!rowData.alloted_date) {
                showInfo("info", "Please select an alloted date.");
                return;
            }
            if ((key === "expired_date" && !newValue) || !rowData.expired_date) {
                showInfo("info", "Please select an expiry date.");
                return;
            }
            const payload = {
                "project_id": projectData?.project_id,
                "product_project_id": projectData?.product_project_id,
                "project_product_code": projectData?.product_code,
                "project_key": projectData?.project_key,
                "is_atlassian": projectData?.is_atlassian,
                "requested_user_code": rowData?.user?.user_code || rowData.user_code,
                "project_role_id": rowData.projectRole?.project_role_id || rowData?.project_role_id,
                "atlassian_product_id": rowData?.user?.product_accountId || rowData.product_accountId || "",
                "is_billable": key === "is_billable" ? newValue : rowData?.is_billable || false,
                "remark": rowData.remark || "",
                "is_build_allow": key === "is_build_allow" ? newValue : rowData.is_build_allow || false,
                "is_server_build_allow": key === "is_server_build_allow" ? newValue : rowData.is_server_build_allow || false,
                "from_date": rowData.alloted_date && dateConvert(rowData.alloted_date, "iso-string"),
                "to_date": key === "expired_date" ? dateConvert(newValue, "iso-string") : rowData.expired_date && dateConvert(rowData.expired_date, "iso-string"),
                "is_auto_build_request_permission": key === "is_auto_build_request_permission" ? newValue : rowData.is_auto_build_request_permission || false,
                "component_id": rowData.component_id || 0,
                "issue_type_ids": rowData?.issueType?.toString() || "",
                "user_product_code": rowData?.user?.product_code || rowData?.product_code || 0,
                "communicators_category_ids": rowData?.communicators_ids?.toString() || ""
            };
            const res = await services.getInvokeRemote("POST", Urls("UPSERTPROJECTMEMBERSDETAILS"), payload);
            if (!res?.body?.error_status) {
                showSuccess("success", res?.body?.message);
                setFilterValues(prev => ({ ...prev, type: true }))
                setFieldValues({})
                getProjectMembers(true);
            } else {
                showError("error", res?.body?.message);
            }
        } catch (error) {
            console.error("error", error);
        }
    };

    const getProjectMembers = async (status) => {
        try {
            const payload = {
                "project_id": projectData?.project_id,
                "product_code": projectData?.product_code,
                "is_current": status
            }
            const res = await services.getInvokeRemote("POST", Urls("GETPROJECTMEMBERSDETAILS"), payload);
            if (!res?.body?.error_status) {
                const totalCount = res?.body?.data?.members_category_counts?.reduce((total, category) => {
                    return total + category.category_wise_counts;
                }, 0);
                const categoryDataWithAll = [
                    {
                        category_id: "all",
                        category_name: "All",
                        category_key: "all",
                        category_wise_counts: totalCount
                    },
                    ...res?.body?.data?.members_category_counts?.map(cat => ({
                        ...cat,
                        category_wise_counts: cat.category_wise_counts || 0
                    }))
                ];

                setCategoryData(categoryDataWithAll);
                const full_obj = res?.body?.data?.members_role?.map(obj => {
                    return {
                        ...obj,
                        issueType: _.pluck(_.filter(res?.body?.data?.members_issue_types, { user_code: obj.user_code }), "issue_type_id"),
                        communicators_ids: obj?.communicator_category_ids?.split(",").map(id => Number(id.trim()))
                    };

                });
                const categoryWiseData = full_obj.reduce((groups, item) => {
                    const category = item.category_name;
                    if (!groups[category]) {
                        groups[category] = {
                            title: category || "Other",
                            id: item?.category_id || "Other",
                            children: []
                        };
                    }
                    groups[category].children.push(item);
                    return groups;
                }, {});
                setMemberList(Object.values(categoryWiseData))
                // setFilterData(Object.values(categoryWiseData))
            }
        } catch (error) {
            console.error("error", error)
        }
    }

    useEffect(() => {
        projectData?.project_id && getProjectMembers(true)
    }, [projectData?.project_id]);

    const deleteMember = async (row) => {
        try {
            const payload = {
                "project_id": row?.project_id,
                "is_atlassian": true,
                "project_user_code": row?.user_code,
                "project_role_id": row?.project_role_id,
                "atlassian_product_id": row?.product_accountId || ""
            }
            const res = await services.getInvokeRemote("POST", Urls("REMOVEPROJECTMEMBERSDETAILS"), payload);
            if (!res?.body?.error_status) {
                showSuccess("success", res?.body?.message);
                getProjectMembers(true);
            } else {
                showError("error", res?.body?.message);
            }
        } catch (error) {
            console.error(error)
        }
    }

    return useMemo(() => ({
        categoryData, formJson, handleChange, fieldValues, setFieldValues, showAddInput, setShowAddInput, showPopup, setShowPopup, showInfo, upsertUserRoleAPI, columns, filterValues, setFilterValues, filterData, getProjectMembers
    }), [categoryData, formJson, handleChange, fieldValues, setFieldValues, showAddInput, setShowAddInput, showPopup, setShowPopup, showInfo, upsertUserRoleAPI, columns, filterValues, setFilterValues, filterData, getProjectMembers])
}